import Raven from 'raven-js'
import Mixpanel from 'mixpanel-browser'

import { storage as getStorage } from './index.js'

const storage = getStorage()

export const userId = () => getUser() && getUser().id || storage && storage.getItem('user_id') || null
export const userToken = () => storage && storage.getItem('user_token') || null
export const isAdmin = () => !!(storage && storage.getItem('is_admin'))
export const isLoggedIn = () => !!userToken()

export const getUser = () => storage && JSON.parse(storage.getItem('user')) || {}

export const setAuth = ({ user_token, user }) => {
  storage && storage.setItem('user_token', user_token)
  setUser(user)
}

export const setUser = user => {
  let obj = JSON.stringify(user)
  // just save some room in storage
  delete obj.created_by
  delete obj.created_at
  delete obj.updated_by
  delete obj.updated_at

  storage && storage.setItem('user', obj)
  storage && storage.setItem('user_id', user.id)

  if (user.is_admin) { // if admin, create key, otherwise no reason to
    storage && storage.setItem('is_admin', !!user.is_admin)
  }

  // add user context to logging
  Mixpanel.people.set({
    $name: user.email,
    $email: user.email,
    customers: user && user.customers && user.customers.filter(o => o && o.name).map(o => o.name),
    is_admin: user.is_admin
  })
  Mixpanel.identify(user.id)

  Raven.setUserContext({
    id: user.id,
    email: user.email,
    customers: user && user.customers && user.customers.filter(o => o && o.name).map(o => o.name),
    is_admin: user.is_admin
  })
}

export const removeAuth = () => {
  storage && storage.removeItem('user_token')
  storage && storage.removeItem('user_id')
  storage && storage.removeItem('user')
  storage && storage.removeItem('is_admin')

  // remove sentry.io user context
  Raven.setUserContext()
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js